var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArbre1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_9",
    "data-name": "Calque 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 406 1062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#965d36;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#559914;}.cls-5{fill:#3e7f13;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-1104 -1133)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1321,1805c-297.35-13.57-47-672,0-672C1385,1133,1574,1805,1321,1805Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arbre 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1323,1787v408h-36l16-429Z",
    transform: "translate(-1104 -1133)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1321,1805c-297.35-13.57-47-672,0-672C1385,1133,1574,1805,1321,1805Z",
    transform: "translate(-1104 -1133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1441.75,1673.28C1298,1699.55,1237.39,1576.2,1199,1413c0,0-95,182-95,191s57,217,57,217l248,66,101-100Z",
    transform: "translate(-1104 -1133)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbre1);
export default __webpack_public_path__ + "static/media/arbre_1.bd9687db7eeff0e528ee731ed94187e0.svg";
export { ForwardRef as ReactComponent };